import scrollEvent from '../fsUtils/scrollEvent';
import Viewports from "../fsUtils/Viewports";

class skinAdsPin {

    constructor() {
        this.skinAd = null;
        this.skinAdElm = null;
        this.skinAdPos = 0;
        this.skinAdPinned = false;
        this.skinAdPinTopPos = 0;
        this.lastScrollTop = 0;
        // elements
        this.secNav = document.querySelector('.section-nav');
        this.mainStory = document.getElementById("story-1");
        this.secNavHeight = this.getSecNavHeight();
        this.viewports = new Viewports();

        this.init();

    }
    init() {

        window.addEventListener("scroll", () => {
            scrollEvent.debounce(10, this.toggleSkinAdPosOnScroll());
        });

    }
    getSecNavHeight() {
        let secNav = this.secNav;
        if (secNav !== undefined && secNav !== null) {
            return secNav.offsetHeight;
        }
        return 0;
    }

    setSkinAdPos(pos) {
        this.skinAdPos = pos;
    }

    getSkinAdPos() {
        return this.skinAdPos;
    }

    hasSkinAd() {
        this.skinAd = document.querySelector('.skin-bd');
        if (this.skinAd) {
            return true;
        }
        return false;
    }

    getSkinAdEl() {
        return document.getElementById('SkinContainer');
    }

    getSkinAdHeight() {
        return this.skinAd.offsetHeight;
    }
    pinSkinAd(skinAdElm) {
        skinAdElm.classList.remove('skinAdUnPin');
        skinAdElm.classList.add('skinAdPin');
    }
    unPinSkinAd(skinAdElm) {
        skinAdElm.classList.remove('skinAdPin');
        skinAdElm.classList.add('skinAdUnPin');
    }
    toggleSkinAdPosOnScroll() {

        let st = window.pageYOffset || document.documentElement.scrollTop;
        if (this.viewports.getViewPort() === 'desktop') {

            let hasSkinAd = this.hasSkinAd();
            let skinAdElm = this.getSkinAdEl();

            if (hasSkinAd) {
                let skinAdHeight = this.getSkinAdHeight();
                let secNavHeight = this.secNavHeight;
                let mainStoryBottomPos = (this.mainStory) ? this.mainStory.getBoundingClientRect().bottom : 0;
                let bottomOffsetPos = skinAdHeight + secNavHeight;
                let isAdPinned = this.skinAdPinned;
                let offsets = parseInt(mainStoryBottomPos - 100.0);
                // Downscroll
                if (st > this.lastScrollTop) {
                    if (st >= secNavHeight) {
                        this.skinAd.style.transition = 'none';
                        this.pinSkinAd(skinAdElm);
                    }
                    if (this.mainStory) {
                        if (offsets <= bottomOffsetPos) {
                            this.skinAd.style.transition = null;
                            this.skinAd.classList.add('push-up');
                        }
                    }
                } else {
                    if (st < (this.lastScrollTop - 1)) {
                        if (st <= secNavHeight) {
                            this.skinAd.style.transition = 'none';
                            this.unPinSkinAd(skinAdElm);
                        }
                        if (this.mainStory) {
                            if (offsets >= bottomOffsetPos) {
                                this.skinAd.classList.remove('push-up');
                            }
                        }
                    }
                }
            }
            this.lastScrollTop = st;
        }
    }

    updateSkinAdPosition(i) {

        var that = this,
            position = that.skinAd.css('position'),
            topPos = that.getSkinAdPos(),
            skinAdPinTopPos = that.skinAdPinTopPos;

        if (i === 2 && position !== 'absolute') {

            that.skinAd.css({ position: 'absolute', top: topPos });

        } else if (i === 1 && position !== 'fixed') {

            that.skinAd.css({ position: 'fixed', top: skinAdPinTopPos });
        }

    }

    toggleSkinAdPosOnClick(mainStoryPos) {
        //toggle skin ad when clicking three things

        var that = this,
            hasSkinAd = hasSkinAd || that.hasSkinAd();

        if (hasSkinAd && mainStoryPos !== undefined) {

            var skinAdHeight = that.getSkinAdHeight(),
                offset = storyProperties.belowNavAd.offsetHeight;

            var unPinPos = mainStoryPos.bottom + offset - skinAdHeight;

            that.setSkinAdPos(unPinPos);

            that.updateSkinAdPosition(2);

            that.skinAdPinned = false;
        }
    }
}
export default new skinAdsPin();


// WEBPACK FOOTER //
// ./assets/components/ads/skinAdsPin.js